module.exports = __webpack_public_path__ + "static/ordinary-men-3b22ed00b03622ab171c0c6d9c4a3873.jpg";